module.exports = __webpack_public_path__ + "img/diente.210eb6b5.svg";